/**
 * DisplayModeProvider Component
 * Provides display mode context to the entire application
 */

import { type ReactNode } from 'react';
import { useDisplayMode } from '../../hooks/useDisplayMode';
import { DisplayModeContext } from '../../contexts/DisplayModeContext';

interface DisplayModeProviderProps {
  children: ReactNode;
}

/**
 * Provider component that wraps the application with display mode context
 */
export function DisplayModeProvider({ children }: DisplayModeProviderProps) {
  const displayModeConfig = useDisplayMode();

  return (
    <DisplayModeContext.Provider value={displayModeConfig}>
      {children}
    </DisplayModeContext.Provider>
  );
}
